import React from 'react';
import styled from 'react-emotion';
import PropTypes from 'prop-types';

const CenterDiv = styled.div`
  position: absolute;
  z-index: 9;
  width: 100%;
  height: 100%;
  background-color: ${props => props.theme.colors.night.tint};
`;

const FxTint = props => {
  const { children } = props;
  return <CenterDiv style={{ backgroundColor: `${props.color}`, opacity: `${props.opacity}` }}>{children}</CenterDiv>;
};
export default FxTint;

FxTint.propTypes = {
  children: PropTypes.node,
  color: PropTypes.string,
  opacity: PropTypes.number,
};

FxTint.defaultProps = {
  color: '',
  opacity: 0.25,
};



// WEBPACK FOOTER //
// ./src/components/FxTint.jsx